export default {
    TAX_PROFILE: 'companies/:company_id/tax-profile/'
}
